import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react';

const CustomSelect = (props) => {
  const {
    title, value, options, optionValue, optionTitle, func, state, index
  } = props;
  return (
    <FormControl variant="filled" sx={{ m: 0, minWidth: 120, background: 'white' }}>
      <InputLabel id="select-Quantity">{title}</InputLabel>
      <Select
        labelId="demo-simple-select-filled-label"
        id="select-Quantity-filled"
        value={value}
        onChange={e => func(e.target.value, index, state)}
          >
        {options && options.map(option => <MenuItem value={option[optionValue]}>{option[optionTitle]}</MenuItem>)}
      </Select>
    </FormControl>
  );
};

export default CustomSelect;


